import React, { useEffect, useState } from 'react'
import DynamicForm from '../../../customformComponent/customForm/DynamicForm';
import { useLocation, useNavigate } from 'react-router-dom';
import backicon from "../../../../Assets/icons/backIcon.svg";
import ROUTES_NAVIGATION from '../../../../routes/routes';
import CustomTable from '../../../customComponents/CustomTable';
import { TABLE_DATA, TABLE_HEADERS, keyMapping } from '../../../../constants/Spareparts';
import downloadIcon from "../../../../Assets/icons/download.svg"
import axiosInstance from '../../../services/api/API';
import Loader from '../../../customComponents/CustomLoader';


 

const AddSpareParts = ({isSparePartDetailsSubmitted,setisSparePartDetailsSubmitted,isdistributor,logisticID,  LOGISTICID,BUSINESSPARTNERID}) => {
  console.log("isdistributorspareparts",logisticID);
  

    const [formData, setFormData] = useState({});
    const [iseditmode,setisEditMode] = useState(false)
    const [validationErrors,setValidationErrors] = useState({})
    const [loading, setLoading] = useState(true);
    const [variantOptions, setVariantOptions] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const [parttypeOptions, setPartTypeOptions] = useState([]);
    const [warrantyOptions, setWarrantyOptions] = useState([]);
    const [productRequirementOptions, setProductRequirementOptions] = useState([]);
    const [sparePartOptions,setSparePartOptions]= useState([])
    const [PartOptions,setPartOptions]= useState([])
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [tableData, setTableData] = useState([]);
    const [logisticstockid,setLogisticStockId] = useState(0)
    const location=useLocation();
    const editlogisticid=location?.state?.data?.logistic_id
    const editBusinessPartnerID= location?.state?.data?.business_partner_id
    const logistic_id = localStorage.getItem('logistic_id');
  

    const navigate = useNavigate();
   const token = localStorage.getItem("authToken");
   console.log("tabledata>>>",tableData);
   
   const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchLogisticData(newPage); 
  };
  const fetchproductRequirementOptions = async() => {
    try {
    const partResponse = await axiosInstance.post('/logisticsstock/ddlproductrequirement', { business_partner_id: 1 }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const productreqOptions = partResponse.data.data?.map(product => ({
      label:product.NAME,
      value: product.ID,
    }));
    setProductRequirementOptions(productreqOptions);
  } catch (error) {
    console.log(error);
    
    
  }
}
const fetchPartTypeOptions = async() => {
  try {
  const partResponse = await axiosInstance.post('/logisticsstock/ddlparttype', { business_partner_id: 1 }, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const parttypeOptions = partResponse.data.data?.map(product => ({
    label:product.NAME,
    value: product.ID,
  }));
  setPartTypeOptions(parttypeOptions);
} catch (error) {
  console.log(error);
  
  
}
}
const fetchWarrantyeOptions = async() => {
  try {
  const partResponse = await axiosInstance.post('/warranty/ddlwarranty', { business_partner_id: BUSINESSPARTNERID }, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const warrantyOptions = partResponse.data?.data?.data?.map(product => ({
    label:product.NAME,
    value: product.ID,
  }));
  console.log("warrantyOptions",warrantyOptions);
  
  setWarrantyOptions(warrantyOptions);
} catch (error) {
  console.log(error); 
  
}

}
console.log("warrantyOptions>>>",warrantyOptions);

  const fetchPartCategoryOptions = async() => {
    try {
    const partResponse = await axiosInstance.post('/partcategory/ddlpartcategory', { business_partner_id: 1 }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const partOptions = partResponse.data.data.data?.map(product => ({
      label:product.NAME,
      value: product.ID,
    }));
    setPartOptions(partOptions);
  } catch (error) {
    console.log(error);
    
    
  }
}
  const fetchSparePartOptions = async() => {
    try {
    const sparepartResponse = await axiosInstance.post('/item/ddlitem', { business_partner_id: BUSINESSPARTNERID,itemtype_id:1 }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const spareOptions = sparepartResponse.data.data.data?.map(product => ({
      label:product.NAME,
      value: product.ID,
    }));
    setSparePartOptions(spareOptions);
  } catch (error) {
    console.log(error);
    
    
  }
}
  const fetchProductOptions = async() => {
    try {
    const productResponse = await axiosInstance.post('/product/ddlproduct', { business_partner_id: BUSINESSPARTNERID || editBusinessPartnerID}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const productOptions = productResponse.data.data.data?.map(product => ({
      label:product.NAME,
      value: product.ID,
    }));
    setProductOptions(productOptions);
  } catch (error) {
    console.log(error);
    
    
  }
}
  useEffect(()=>{
    fetchProductOptions(); 
    fetchSparePartOptions(); 
    fetchPartCategoryOptions();
    fetchproductRequirementOptions();
    fetchPartTypeOptions();
    fetchWarrantyeOptions();
  },[])
  // useEffect(() => {



  //   if (formData.spare_parts) {
  //     console.log("formData",formData);
  //     const fetchSparePartDetails = async () => {
  //       try {
  //         const token = localStorage.getItem("authToken");
          
  //         const response = await axiosInstance.post('/item/ddlitembase', {
  //         itemtype_id:1,//1 for Spare-Parts//2 for accessory
  //         business_partner_id: 1,
  //         item_id:formData?.spare_parts
  //         }, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         });
  //             const sparepartdetails = response?.data?.data?.data[0]
  //         setSparePartDetails(sparepartdetails)
  //         console.log("sparePartDetails",sparepartdetails);
          
  //     setFormData({
  //       ...formData,
  //       sellingprice:sparepartdetails?.selling_price,
  //       purchaseprice:sparepartdetails?.purchase_price,
  //       warranty:sparepartdetails?.warranty_name

        
      
  //     })
  //       } catch (error) {
  //         console.error("Error fetching variant options:", error);
  //       }
  //     };

  //     fetchSparePartDetails()
  //   }
  // }, [formData.spare_parts]);
  useEffect(() => {


    if (formData.productname) {
      console.log("formData",formData);
      const fetchVariantOptions = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const response = await axiosInstance.post('/variant/ddlvariant', {
            business_partner_id: BUSINESSPARTNERID,
            product_id: formData.productname
          }, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
          const variantOptions = response.data.data.data?.map(variant => ({
            label:variant.NAME,
            value: variant.ID,
          }));
          

          setVariantOptions(variantOptions);
        } catch (error) {
          console.error("Error fetching variant options:", error);
        }
      };

      fetchVariantOptions();
    }
  }, [formData.productname]);

  

  useEffect(() => {
    if (formData?.variant) {
      const fetchVariantBasedDetails = async () => {
        try {
       
          const response = await axiosInstance.post('/variant/ddlvariantbasedetails', {
            //business_partner_id: 1,
            variant_id: formData.variant
          }, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

          const variantwisedata = response?.data?.data?.data[0]
          console.log("variantwisedata",variantwisedata);

          setFormData({
            ...formData,
            
            fueltype:variantwisedata?.fuel_type_name,
            subproduct:variantwisedata?.subproduct_name,
            make:variantwisedata?.make_name,
            model:variantwisedata?.model_name,
            exshowroomprice:variantwisedata?.exshowroom_price,
            color:variantwisedata?.color_name,
            price:variantwisedata?.exshowroom_price
            
          });
          // const variantOptions = response.data.data.data?.map(variant => ({
          //   label:variant.NAME,
          //   value: variant.ID,
          // }));
          

          // setVariantOptions(variantOptions);
        } catch (error) {
          console.error("Error fetching variant options:", error);
        }
      };

      fetchVariantBasedDetails();
    }
  }, [formData?.variant]);

  const handleFormSubmit = async(data) => {
    // Convert multiselectdropdown data to a readable format
    setisSparePartDetailsSubmitted(true)
    const errors = {};
    let isValid = true;
     CustomerInputs.forEach((field) => {
      console.log("field>>",field);
      if (field.required && !formData[field.name]) {

        errors[field.name] = "This field is required";
        isValid = false;
      } else if ( field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      console.log("validationErrors",validationErrors);
      return;
    }

    

  try {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    if(iseditmode){
      const response = await axiosInstance.patch(`/logisticsstock/update/${logisticstockid}`, {
        stock_type:"S"||null,
        business_partner_id:BUSINESSPARTNERID || editBusinessPartnerID,
        logistic_id:logisticID ||  editlogisticid ||LOGISTICID,
        product_id:data?.productname || null,
        variant_id:data?.variant || null,
        vehicle_id:1||null,
        purchase_price:data?.purchaseprice,
        selling_price:data?.sellingprice,
        serial_no:data?.serialno,
        item_id:data?.spare_parts|| null,
        part_category_id:data?.partcategory ||null,
        product_requirement_id:data?.productrequirement || null,
        part_type_id:data?.parttype||null,
        remark:formData?.remark || "none",
        warranty_id:data?.warranty
     
         
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
    
        console.log("API Response:", response.data);

       
        setisSparePartDetailsSubmitted(true)

    }
    else{
      const response = await axiosInstance.post(`/logisticsstock/create`, {
        stock_type:"S"||null,
        business_partner_id:BUSINESSPARTNERID || editBusinessPartnerID,
        logistic_id: editlogisticid || logisticID ||LOGISTICID,
        product_id:data?.productname || null,
        variant_id:data?.variant || null,
        vehicle_id:1||null,
        serial_no:data?.serialno,
        purchase_price:data?.purchaseprice,
        selling_price:data?.sellingprice,
        item_id:data?.spare_parts|| null,
        part_category_id:data?.partcategory ||null,
        product_requirement_id:data?.productrequirement || null,
        part_type_id:data?.parttype||null,
        remark:formData?.remark || "none",
        warranty_id:data?.warranty
     
         
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
    
      
        setisSparePartDetailsSubmitted(true)
      
    }
    setFormData({})
    fetchLogisticData();
   // navigate(ROUTES_NAVIGATION.ADVANCESEARCH);
  } catch (error) {
    console.error("Error submitting form:", error);
  }
  finally{
    setLoading(false)
  }
  
   
  };

  const CustomerInputs = [

    {
      name: "productname",
      label: "Product",
      type: "dropdown",
      options:productOptions,
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
    },
    {
      name: "variant",
      label: "Variant",
      type: "dropdown",
      options:variantOptions,
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
    },
    {
      name: "subproduct",
      label: "Sub Product",
      type: "text",
      disabled:true,
      
      gridClass: "col-lg-4",
    },
    {
      name: "make",
      label: "Make",
      type: "text",
      disabled:true,
      
      gridClass: "col-lg-4",
    },
    {
      name: "model",
      label: "Model",
      type: "text",
      
      disabled:true,
      gridClass: "col-lg-4",
    },
    {
        name: "fueltype",
        label: "Fuel Type",
        type: "text",
        disabled:true,
        
        gridClass: "col-lg-4",
      },
    {
      name: "color",
      label: "Color",
      type: "text",
      disabled:true,
      
      gridClass: "col-lg-4",
    },
    {
      name: "serialno",
      label: "Serial No.",
      type: "text",
      placeholder:"Enter Serial No.",
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
    },
    {
      name: "spare_parts",
      label: "Spare Parts",
      type: "dropdown",
      options:sparePartOptions,
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
    },

    {
      name: "purchaseprice",
      label: "Purchase Price",
      type: "text",
      placeholder:"Enter Purchase Price",
      validation: { 
        required: true,
        pattern: /^[0-9]+(\.[0-9]{1,2})?$/, 
        message: "Please enter a valid purchase price with up to 2 decimal points*"
      },
     // disabled:true,
      gridClass: "col-lg-4",
    },
    {
      name: "sellingprice",
      label: "Selling Price",
      type: "text",
      placeholder:"Enter Selling Price",
      validation: { 
        required: true,
        pattern: /^[0-9]+(\.[0-9]{1,2})?$/, 
        message: "Please enter a valid selling price with up to 2 decimal points*"
      },
     // disabled:true,
      gridClass: "col-lg-4",
    },
  
    {
      name: "partcategory",
      label: "Part Category",
      type: "dropdown",
      options:PartOptions,
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
    },
    {
      name: "parttype",
      label: "Part Type",
      type: "dropdown",
      options:parttypeOptions,
     // validation:{required:true},
      isVisible:false,
    required:false,
      gridClass: "col-lg-4",
    },
    
    {
      name: "warranty",
      label: "Warranty",
      type: "dropdown",
      options:warrantyOptions,
     // disabled:true,
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
    },
    {
      name: "productrequirement",
      label: "Product Requirement",
      type: "dropdown",
      options:productRequirementOptions,
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
    },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      required: true,
      placeholder:"Enter Remark",
      validation:{required:true},
      gridClass: "col-lg-4",
    },
  ];
  useEffect(() => {
    fetchLogisticData();
  }, []);

  
  const fetchLogisticData = async (page=0 , pageSize=10 ) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        '/logisticsstock/list',
        {
          logistic_id: logisticID ||LOGISTICID,
          stock_type: "S",  
         orderBy:"logistic_id desc",
      page,
      pageSize,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
      }));
  
      const totalRecordsData = response?.data?.data?.totalRecords
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);
  
      setTableData(formattedData);
     // toastSuccess("Product Data fetched successfully!");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching vendor list:', error);
    }
    finally{
      setLoading(false)
    }
  };
  const handleDelete = async (rowData) => {
    try {
      const response = await axiosInstance.delete(`/logisticsstock/delete/${rowData.logistic_stock_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        // Create a new array without the deleted item
        const updatedData = tableData.filter(item => item.logistic_stock_id !== rowData.logistic_stock_id);
        setTableData(updatedData);
        console.log('Item deleted successfully');
      } else {
        console.error('Failed to delete item');
      }
    } catch (error) {
      console.error('Error deleting item:', error);
    }
  }
  const handleEdit = async (rowData) => {
   
    
    setisEditMode(true)
   
    try {
      const response = await axiosInstance.get(`/logisticsstock/edit/${rowData.logistic_stock_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const vehicleData = response.data.data; 
        setLogisticStockId(vehicleData?.logistic_stock_id)
        console.log("vehicleData>>",vehicleData);

                
        const transformedData = {
          productname:vehicleData.product_id,
          variant: vehicleData.variant_id,
          subproduct:vehicleData?.subproduct_name,
          make: vehicleData.make_name,
          model: vehicleData.model_name,
          fueltype:vehicleData?.fuel_type_name,
          color:vehicleData?.color_name,
          price:vehicleData?.exshowroom_price,
          serialno:vehicleData?.serial_no,
          spare_parts:vehicleData?.item_id,
          partcategory:vehicleData?.part_category_id,
          parttype:vehicleData?.part_type_id,
          purchaseprice:vehicleData?.purchase_price,
          productrequirement:vehicleData?.product_requirement_id,
          warranty:vehicleData?.warranty_id,
          remark:vehicleData?.remark,
          sellingprice:vehicleData?.selling_price,

        
      };
        setFormData(transformedData)
    console.log("vehicleformData",formData);
    
      } else {
        console.error('Failed to fetch vehicle data');
      }
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    }
  }
  return (
    <>
      {/* <div className="backbutton mt-2 mb-2">
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Logistics</span>
      </div> */}
      
        <div className="d-flex flex-row justify-content-between" style={{marginBottom:"25px"}}>
            <div>
        <span className="cust-det-title mt-2 mb-2">
          Add Spare Parts
        </span>
            </div>
            {/* <div className="d-flex justify-content-center align-items-center flex-row gap-2">
                <button onClick={addVehicleNavigation}  className="logistics-btn">Add Vehicle Details</button>
                <button onClick={spareNavigation}  className="submit-btn">Add Spare Parts</button>
                <button onClick={addAccessoriesNavigation}  className="logistics-btn">Add Accessories</button>
            </div> */}
        </div>
        <div>
        {loading ? ( 
      <Loader />
    ) : (
      <div>
        <DynamicForm
        //formConfig={CustomerInputs}
          formConfig={CustomerInputs.filter(input => {
            if (input.name === "parttype") {
              return isdistributor 
            }
            return true; 
          }).map(input => {
            if (input.name === "parttype") {
              return {
                ...input,
                isVisible: isdistributor, 
                required:isdistributor
              };
            }
            return input;
          })}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          onDelete={handleDelete}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
     

      <div className="btncontainer mt-3 gap-2">
        {/* <button style={{backgroundColor:"#fff", padding:"10px 20px" , borderRadius:"10px", color:"#7BD755", border:"1px solid #7BD755"}}>
            Back
        </button> */}
        <button
        onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          {iseditmode ? "Update":"Submit"}
        </button>
      </div>

{/* Table */}

      <div className='tableWrapper'>
      <div className='admin-list-container'>
      <div className='listsearchContainer'>
        <h5>Spare Part Details</h5>
        
        {/* <input type='text' className='searchinput' placeholder='Search Source' /> */}
      </div>
      {/* <div className='downloadiconwrapper'>
        <h6 className='downloadTitle'>Download</h6><img src={downloadIcon} alt='download'/>
      </div> */}
      </div>
     
      <CustomTable 
      data={tableData} headers={TABLE_HEADERS} keyMapping={keyMapping} onDelete={handleDelete} itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit} 
          totalRecords={totalRecords} />
      </div>
      </div>
    )}
    </div>
    </>
    
  )
}

export default AddSpareParts;